import React from 'react';
import './Card.scss';

function Card(props: { children: React.ReactElement, className?: string }): JSX.Element {
  const { children, className } = props;

  return (
    <article className={`card ${className}`}>
      {children}
    </article>
  );
}

Card.defaultProps = {
  className: false,
};

export default Card;
